/*
 * @Author: shiguang
 * @Date: 2023-04-26 10:22:04
 * @LastEditors: yusha
 * @LastEditTime: 2024-07-15 09:56:51
 * @Description: 56
 */

export enum ENUM_PICK_MAP_TYPE {
    /** 选择 map 中部分 key 映射到 options */
    PICK = 1,
    /** 剔除 map 中部分 key 映射到 options */
    OMIT = 2,
    /** 所有 map 中 key 映射到 options */
    ALL = 3
}

export enum ENUM_PAGE {
    /** 登录账号管理 */
    SETUP_ACCOUNT = '/vip/setupUser',
    /** 店铺采购管理 */
    SETUP_SHOP = '/authorized/setupShop',
    /** 我收藏的商品/店铺 */
    PRODUCT_COLLECT = '/product/CollectProduct',
    /** 我买过的商品/店铺 */
    PRODUCT_AFTER_PURCHASE = '/product/AfterPurchase',
    /** 我看过的商品/店铺 */
    PRODUCT_FOOT_PRINT = '/product/FootPrint',
    /** 我的钱包 */
    FUND_STORE_FUND = '/fund/StoreFund',
    /** 帮助 */
    HELP = '/help',
    /** 报价信息 */
    QUOTATION_INFO = '/oem/order/quotationInfo',
    /** 新增寻源 */
    ADD_FIND_SOURCE = '/oem/order/addFindSource',
    /** 寻源单详情 */
    FIND_SOURCE_DETAIL = '/oem/order/findSourceDetail',
    /** 寻源单编辑 */
    EDIT_FIND_SOURCE = '/oem/order/editFindSource',
    /** 寻源商品列表 */
    OEM_GOODS_LIST = '/oem/goods/list',
    /** oem 寻源列表 */
    OEM_FIND_SOURCE_LIST = '/oem/order/oemSourceList',
    /** oem 工作台 */
    WORKER_SPACE = '/user/UserCenter',
    /** oem 会员中心 */
    VIP_LEVEL = '/vip/VipLevel',
    /** oem 推广联盟 */
    MY_PROMOTION = '/smc/promotion/Index?redirect=MyPromotion&lang=jp',
    /** oem 购物车 */
    SHOP_CART = '/shopcart',
    /** oem 购物车 */
    INFORMATION = '/vip/Information'
}

/** 系统类型 1-D2C; 2-B2B （后端字段 system_source） */
export enum ENUM_SYSTEM_SOURCE {
    /** D2C */
    D2C = 1,
    /** B2B */
    B2B = 2
}

/** 主子账号类型 （后端字段 account_type） */
export enum ENUM_ACCOUNT_TYPE {
    /** 主账号 */
    PARENT = 1,
    /** 子账号 */
    CHILD = 2
}

/** 页面配置 */
export interface PageConfig {
    /** 登录账号管理 */
    [ENUM_PAGE.SETUP_ACCOUNT]: {};
    /** 店铺采购管理 */
    [ENUM_PAGE.SETUP_SHOP]: {};
    /** 我收藏的商品/店铺 */
    [ENUM_PAGE.PRODUCT_COLLECT]: {};
    /** 我买过的商品/店铺 */
    [ENUM_PAGE.PRODUCT_AFTER_PURCHASE]: {};
    /** 我买过的商品/店铺 */
    [ENUM_PAGE.PRODUCT_FOOT_PRINT]: {};
    /** 我的钱包 */
    [ENUM_PAGE.FUND_STORE_FUND]: {};
    /** 帮助 */
    [ENUM_PAGE.HELP]: {
        query: {
            tab: number;
            /** tab 下面左侧tab 的 id */
            id: number;
        };
    };
    /** 报价信息 */
    [ENUM_PAGE.QUOTATION_INFO]: {
        query?: {
            rowItem?: string;
        };
    };
    /** 添加寻源单 */
    [ENUM_PAGE.ADD_FIND_SOURCE]: {
        query?: {
            searchSourceOrderId?: number;
        };
    };
    /** 寻源单详情 */
    [ENUM_PAGE.FIND_SOURCE_DETAIL]: {
        query?: {
            searchSourceOrderId?: number;
        };
    };
    /** 编辑寻源单 */
    [ENUM_PAGE.EDIT_FIND_SOURCE]: {
        query?: {
            searchSourceOrderId?: number;
        };
    };
    /** 寻源商品列表 */
    [ENUM_PAGE.OEM_GOODS_LIST]: {};
    /** oem 寻源列表 */
    [ENUM_PAGE.OEM_FIND_SOURCE_LIST]: {};
    /** oem 工作台 */
    [ENUM_PAGE.WORKER_SPACE]: {};
    /** oem 会员中心 */
    [ENUM_PAGE.VIP_LEVEL]: {};
    /** oem 推广联盟 */
    [ENUM_PAGE.MY_PROMOTION]: {};
    [ENUM_PAGE.SHOP_CART]: {};
    [ENUM_PAGE.INFORMATION]: {};
}

/** 寻源列表加购类型 */
export enum ENMU_ADD_CART_TYPE {
    /** 加购样品 */
    SAMPLE = 1,
    /** 加购大货 */
    BLUK = 2,
    /** 复购样品 */
    RE_SAMPLE = 3,
    /** 复购大货 */
    RE_BLUK = 4
}

/* 报价操作类型 */
export enum ENMU_PRICE_OPERATE {
    /* 拒绝新报价 */
    REJECT = 0,
    /* 接受新报价 */
    ACCEPT = 1
}

/** 贷款结算方式 */
export enum ENMU_PAYMENT_TYPE {
    /** 一次性扣款 */
    ONE_TIME_PAYMENT = 0,
    /** 按账期扣款 */
    INSTALLMENT_PAYMENT = 1
}

/** 计费重量类型 */
export enum WEIGHT_THROWING_TYPE {
    // 1-全抛;2-半抛;3-不抛
    ALL_THROW = 1,
    HALF_THROW = 2,
    NOT_THROW = 3
}

export {};

/** 商品图片的兜底图 */
export const BACK_UP_IMG =
    'https://static-s.theckb.com/BusinessMarket/Easy/PC/ckb_backup.png';

// 仓库枚举
export enum ENUM_WARE_COUNTRY {
    // 中国仓
    'CN' = 'CN',
    // 韩国仓
    'KR' = 'KR'
}
